import React from "react";
import AvatarThumb68 from "@/sot/primitives/AvatarThumb68.jsx";

const PROFILE_AVATAR_PLACEHOLDER = "/icons/circular-avatar-placeholder.svg";

export default function PrescriptionPatientCell({
  name,
  subtitle = "",
  avatarUrl = "",
  avatarTraceKey = "",
  avatarSizeClass = "h-11 w-11",
  nameClassName = "text-body-medium text-on-surface",
  subtitleClassName = "text-body-small text-on-surface-var",
}) {
  const resolvedAvatarUrl = String(avatarUrl || "").trim() || PROFILE_AVATAR_PLACEHOLDER;

  const recordAvatarTrace = React.useCallback((event, imageSrc = "") => {
    if (!import.meta.env.DEV || typeof window === "undefined") return;
    const trace = Array.isArray(window.__AFRIMED_PHARMACY_AVATAR_TRACE__)
      ? window.__AFRIMED_PHARMACY_AVATAR_TRACE__
      : [];
    trace.push({
      source: "PrescriptionPatientCell",
      event,
      prescription_id: String(avatarTraceKey || "").trim(),
      patient_name: String(name || "").trim(),
      avatar_prop: String(avatarUrl || "").trim(),
      rendered_img_src: String(imageSrc || "").trim(),
    });
    window.__AFRIMED_PHARMACY_AVATAR_TRACE__ = trace;
  }, [avatarTraceKey, avatarUrl, name]);

  React.useEffect(() => {
    recordAvatarTrace("avatar_component_render", resolvedAvatarUrl);
  }, [recordAvatarTrace, resolvedAvatarUrl]);

  return (
    <div className="flex min-w-0 items-center gap-3">
      <AvatarThumb68
        src={resolvedAvatarUrl}
        alt=""
        role="patient"
        shape="circle"
        size={44}
        className={avatarSizeClass}
        fallbackSrc={PROFILE_AVATAR_PLACEHOLDER}
        onImageLoad={(event) => recordAvatarTrace("image_loaded", event.currentTarget.currentSrc || event.currentTarget.src)}
        onImageError={(event) => recordAvatarTrace("image_error", event.currentTarget.currentSrc || event.currentTarget.src)}
      />

      <div className="min-w-0">
        <div className={["truncate", nameClassName].join(" ")}>{name || "Patient"}</div>
        {subtitle ? (
          <div className={["truncate", subtitleClassName].join(" ")}>{subtitle}</div>
        ) : null}
      </div>
    </div>
  );
}
